/** Reload the page (a separate module so tests can replace it). */
/* istanbul ignore next -- jsdom's location.reload can't be stubbed */
export function reloadPage(): void {
  window.location.reload();
}
